import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SkipLogicService {

  public actionsArray = [];

  constructor() { }

  public setOperatorArray(rule){
    let operatorArray = [];
    rule?.questionnaireSkipLogicRuleConditions?.forEach(skipCondition => {
      if (skipCondition?.joiningOperator != "") {
        operatorArray.push(skipCondition.joiningOperator);
      }
    })
    return operatorArray;
  }

  public getSkipDetails(questionArray, assessmentId, skipRules) {
    if (assessmentId >= 0 && assessmentId != null) {
      let conditionCheckArray = [];
      this.actionsArray = [];
      let operatorArray = [];
      skipRules?.forEach((rule, ruleIndex) => {
        operatorArray = this.setOperatorArray(rule)
        questionArray.forEach((question, Index) => {
          question.skipRuleFailureForSupportPerson=false;
          let versionItems = question.versionItems;
          rule?.questionnaireSkipLogicRuleConditions?.forEach((skipCondition, conditionIndex) => {
            versionItems.forEach((version, vIndex) => {
              if (version.QuestionnaireItemID == skipCondition.questionnaireItemID) {
                let responseArray = version?.Responses;
                  let assessment = version.assesments.find(val => val.assessmentID === assessmentId);
                  const listObj = responseArray?.find(val => val.ResponseId === version.ResponseId);
                  const listOrder = (listObj?.ListOrder != undefined || listObj?.ListOrder != null) ? listObj?.ListOrder : assessment?.ResponseId;
                  let comparison = this.compareCurrentItem(skipCondition, assessment?.value, listOrder);
                  if (comparison) {
                    conditionCheckArray.splice(conditionIndex, 0, 1);
                  } else {
                    conditionCheckArray.splice(conditionIndex, 0, 0);
                    if (question.FocusId === 2) {
                      question.skipRuleFailureForSupportPerson= true;
                     }
                  }
              }
            });
          });
        });
        let skipLogicArray = [];
        let ruleAction = questionArray.some(question => question.skipRuleFailureForSupportPerson) ? [] : rule?.questionnaireSkipLogicRuleActions;
       skipLogicArray = this.setSkipLogic(conditionCheckArray, operatorArray);
        this.applyRuleToCondition(skipLogicArray, ruleAction);
        conditionCheckArray = [];
        operatorArray = []
      });
      return this.actionsArray;
    }
  }
  public setSkipLogic(conditionCheckArray, operatorArray) {
    let skipLogicArray = [];
    for (let index = 0; index < conditionCheckArray.length; index++) {
      skipLogicArray.push(conditionCheckArray[index])
      if (operatorArray[index] != undefined) {
        skipLogicArray.push(operatorArray[index])
      }
    }
    return skipLogicArray;
  }
  public compareCurrentItem(object, responseValue, listOrder) {
    switch (object.comparisonOperator) {
      case "<": if (responseValue < object.comparisonValue) {
        return true
      } else {
        return false;
      } break;
      case "<=": if (responseValue <= object.comparisonValue) {
        return true
      } else {
        return false;
      } break;
      case ">": if (responseValue > object.comparisonValue) {
        return true
      } else {
        return false;
      } break;
      case ">=": if (responseValue >= object.comparisonValue) {
        return true
      } else {
        return false;
      } break;
      case "=": if (responseValue == object.comparisonValue && listOrder == object.listOrder) {

        return true
      } else {
        return false;
      }
      default: return false;
    }
  }

  public applyRuleToCondition(conditionsArray, ruleArray) {
    if (ruleArray?.length > 0) {
      const operators = [
        { operator: 'and', fn: (a, b) => a && b },
        { operator: 'or', fn: (a, b) => a || b }
      ];
      for (const { operator, fn } of operators) {
        let i = conditionsArray.indexOf(operator);
        while (i !== -1) {
          conditionsArray[i - 1] = fn(conditionsArray[i - 1], conditionsArray[i + 1]);
          conditionsArray.splice(i, 2);
          i = conditionsArray.indexOf(operator, i);
        }
      }
      if (conditionsArray[0] > 0) {
        this.actionsArray.push(...ruleArray);
      }
    }
  }
}

